<template>
  <div class="App-Main-Layout">
    <el-row :gutter="10" type="flex" align="center">
      <el-col :span="5">
        <el-affix target="body" position="top" :offset="0">
          <slot name="left" />
        </el-affix>
      </el-col>
      <el-col :span="19">
        <div class="App-Main-Layout-M-H">
          <!--  -->
          <el-affix target="body" position="top" :offset="0">
            <div class="App-Main-Layout-M">
              <slot name="top" />
            </div>
          </el-affix>
          <!--  -->
          <div class="App-Main-Layout-M">
            <slot name="main" />
          </div>
          <!--  -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},

})
export default class extends Vue {}
</script>

<style lang="scss">
//
// Responsivelly maximum width
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .App-Main-Layout {
    max-width: 990px;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .App-Main-Layout {
    max-width: 1400px;
  }
}

// XX-Large devices (larger desktops, 1400px and up)
@media (min-width: 1400px) {
  .App-Main-Layout {
    max-width: 1800px;
  }
}
//

.App-Main-Layout {
  padding: 0px 0px 0px 0px;
  margin: auto;
  background-color: rgba($--color-white, 0.5);

  //
  // Middle part
  .App-Main-Layout-M {
    // max-width: 650px;
    margin: 0 auto;
  }
  .App-Main-Layout-M-H {
    // padding-right: 12px;
  }
  [app-main-content] {
    background-color: white;
    border-radius: 6px;
    min-height: 90vh;
    padding: 6px;
  }
}
</style>
